<template>
  <div class="container orders-page">
    <v-head></v-head>
    <v-left current="submit" active="submit"></v-left>
    <div>
      <div class="filter-dic clearfix">
        <div class="fl">
          <el-input v-model="filter.client_id" size="small" class="w200" style="width:133px;" placeholder="client_id"></el-input>
          <el-input v-model="filter.client_ip" size="small" class="w200" style="width:133px" placeholder="client_ip"></el-input>
          <el-input v-model="filter.submit_id" size="small" class="w200" style="width:133px" placeholder="submit_id"></el-input>
          <el-select v-model="filter.content_require" size="small" style="width:200px;" placeholder="content require">
            <el-option v-for="item in content_require_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-date-picker
            size="small"
            style="width: 256px"
            v-model="filter.time_range"
            clearable
            @change="search"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
          <el-input
            size="small"
            v-model="filter.keyword"
            placeholder="搜订单号、工厂单号、备注"
            clearable
            @clear="search"
            @change="search"
            style="width: 300px"
            class="w400 input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </div>
        <div class="fr">
          <el-button size="small" @click="redirect('/orders/diy-create')"
            >作品浏览</el-button
          >
        </div>
      </div>

      <div>
        <el-pagination
          class="my-page"
          style="float: left;"
          background
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
        <el-table
          :data="list_data.list"
          v-loading="loading"
          style="width: 100%"
          ref="multipleTable"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column prop="submit_id" label="submit_id" width="400"> 
            <template slot-scope="scope">
              <p>submit_id: {{scope.row.submit_id}}</p>
              <p>client_ip: {{scope.row.client_ip}}</p>
              <p>client_id: {{scope.row.client_id}}</p>
              <p>ctime: {{scope.row.ctime}}</p>
            </template>
          </el-table-column>
          <el-table-column label="recored" min-width="777">
            <template slot-scope="scope">
              <el-table
                :data="scope.row.record"
                v-loading="loading"
                style="width: 100%"
                ref="multipleTable"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange"
                border
              >
                <el-table-column label="id" prop="id" width="100"></el-table-column>
                <el-table-column label="option" prop="design_type_show" width="111"></el-table-column>
                <el-table-column label="file_list" prop="file_list" min-width="300"> 
                  <template slot-scope="scope">
                    <el-image
                      style="width: 64px"
                      :src="f.file_oss"
                      :preview-src-list="[f.file_oss]"
                      v-for="(f, index) in scope.row.file_list" :key="index"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column label="auto" prop="auto" min-width="300"> 
                  <template slot-scope="scope">
                    <el-image
                      style="width: 64px"
                      v-if="scope.row.auto_design"
                      :src="scope.row.auto_design.image_draw"
                      :preview-src-list="[scope.row.auto_design.image_draw]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column label="diy" prop="diy" min-width="300"> 
                  <template slot-scope="scope">
                    <el-image
                      v-if="scope.row.diy_result"
                      style="width: 64px"
                      :src="scope.row.diy_result.image_diy"
                      :preview-src-list="[scope.row.diy_result.image_diy]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column label="ctime" prop="ctime" min-width="200"> </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="my-page"
          background
          :page-size="list_data.size"
          layout="total, prev, pager, next"
          @current-change="changePage"
          :total="list_data.total"
        >
        </el-pagination>
      </div>


    </div>
  </div>
</template>

<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const pop_drag = (resolve) => require(["@/pages/orders/_pop_drag"], resolve);
const pop_pro_image = (resolve) =>
  require(["@/pages/orders/_pop_pro_image"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    pop_drag,
    // pop_produce,
    // pop_produce_add,
    pop_pro_image,
  },
  data() {
    return {
      loading: false,
      popName: null,
      pop_diy_info: null,
      edit_row: null,
      edit_order_goods_row: null,
      multipleSelection: [],
      filter: {
        page: 1,
        size: 20,
        app_id:"",
        keyword: "",
        client_id:"",
        client_ip: "",
        submit_id: "",
        design_type:0,
        content_require:"",
        has_diy:0,
        time_range: [],
      },
      list_data: {
        size: 20,
        page: 1,
        total: 0,
        list: [],
      },
      content_require_options: [
        {value: "upload", label:"有上传"},
        {value: "diy", label:"有DIY"},
        {value: "upload_or_diy", label:"有上传或DIY"},
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    toEditProImage(row) {
      console.log(row, "------------<<>>>");
      this.edit_order_goods_row = row;
      this.popName = "pop_pro_image";
    },
    changePage(e) {
      this.filter.page = e;
      this.getList();
    },
    search() {
      this.filter.page = 1;
      this.getList();
    },
    toPopProduce(row) {
      this.popName = "pop_produce";
      this.edit_row = row;
    },
    toPopDrag(sub) {
      if (sub.diy_info) {
        this.popName = "pop_drag";
        this.pop_diy_info = sub.diy_info;
      }
    },
    getList() {
      this.loading = true;
      this.$http.post("/v1/pri/statics/submit-list", this.filter).then((response) => {
        this.loading = false;
        var res = response.data;
        if (res.code == 1) {
          this.list_data = res.data;
        }
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped>
.orders-page .filter-dic {
  margin-bottom: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/submit/Index.vue